import { createContext, useContext } from 'react';

const SubModalContext = createContext(null);

export const useSubModal = () => {
  const ctx = useContext(SubModalContext);
  if (!ctx) return {};
  return ctx;
};

export default SubModalContext;
